module.exports = __webpack_public_path__ + "static/media/truck-plow.6366cbce.svg";